module.exports = __webpack_public_path__ + "static/media/Corey Mathews Headshot.dddb9ca8.jpeg";